import React from "react"
import PropTypes from "prop-types"
import { connect } from "react-redux"
import { bindActionCreators } from "redux"
// import { fetchObjects, getObjectsAndFields } from "data/objectsReducer"
import { objectActions, fieldActions, getObjectsAndFieldsMap } from "data/objectApi"
import { recordActions } from "data/recordApi"

class WithObject extends React.Component {
    render() {
        const objects = this.props.objectsDict

        if (!objects) return this.props.loading ? this.props.loading : ""
        const object = objects[this.props.objectId]
        if (!object) return this.props.loading ? this.props.loading : ""
        const primaryField = getPrimaryField(object)
        return this.props.children({
            object,
            primaryField,
            onChange: this.props.objectActions.update,
            createField: data =>
                this.props.fieldActions.create({ ...data, object_id: object._sid }),
            createRecord: data =>
                this.props.recordActions.create({ ...data, object_id: object._sid }),
            createObject: this.props.objectActions.create,
            deleteField: this.props.fieldActions.delete,
        })
    }

    constructor(props) {
        super(props)
        props.objectActions.fetch()
    }

    componentWillReceiveProps(newProps) {
        if (newProps.objectId !== this.props.objectId) {
            newProps.objectActions.fetch()
        }
    }
}

WithObject.propTypes = {
    objectId: PropTypes.string.isRequired,
}

function mapStateToProps(state) {
    return {
        objectsDict: getObjectsAndFieldsMap(state),
    }
}

function mapDispatchToProps(dispatch) {
    return {
        objectActions: bindActionCreators(objectActions, dispatch),
        fieldActions: bindActionCreators(fieldActions, dispatch),
        recordActions: bindActionCreators(recordActions, dispatch),
    }
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(WithObject)

const getPrimaryField = object => {
    let primaries = object.fields.filter(field => field.is_primary)
    if (!primaries.length) return { api_name: "_sid" }
    return primaries[0]
}



// WEBPACK FOOTER //
// ./src/data/wrappers/WithObject.js